import { Report } from '@/app/models/costTracking';
import { useUpdateCostTrackingMutation } from '@/app/services/costTrackingApi';
import DrawerButtons from '@/components/common/DrawerButtons';
import ModalPageTitle from '@/components/common/ModalPageTitle';
import { Box, Divider, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ReportItem from '../ReportItem';

interface NewEditRelatedServicesProps {
  selectItem: Report[];
  setDrawerOpen: (open: boolean) => void;
}

export default function NewEditRelatedServices(props: NewEditRelatedServicesProps) {
  const { t } = useTranslation(['costTracking', 'common']);
  const theme = useTheme();
  const { selectItem, setDrawerOpen } = props;

  const [reports, setReports] = useState(() => {
    const reportSections = [
      { name: 'baseline', type: 'BASELINE' },
      { name: 'replanned', type: 'REPLANNED' },
      { name: 'fulfilled', type: 'FULFILLED' },
    ];

    return reportSections.map((section, index) => {
      const report = selectItem.find((r) => r.planningReportType === section.type);
      return {
        id: report?.id || index,
        planningReportType: section.name,
        value: report?.value || 0,
        valueSecondary: report?.valueSecondary || 0,
        justify: report?.justify || '',
        justifySecondary: report?.justifySecondary || '',
      };
    });
  });

  const handleCancel = () => {
    setDrawerOpen(false);
  };

  const handleJustificationChange = (index: number, newValue: string) => {
    const updatedReports = [...reports];
    updatedReports[index].justify = newValue;
    setReports(updatedReports);
  };

  const handleJustifySecondaryChange = (index: number, newValue: string) => {
    const updatedReports = [...reports];
    updatedReports[index].justifySecondary = newValue;
    setReports(updatedReports);
  };

  const [update] = useUpdateCostTrackingMutation();

  const handleSubmit = async () => {
    setDrawerOpen(false);
    await toast.promise(
      update({
        list: reports.map((report) => ({
          id: report.id,
          justify: report.justify,
          justifySecondary: report.justifySecondary,
        })),
      }).unwrap(),
      {
        pending: t('common:processing.wait.a.moment') as string,
        success: t('common:comments.saved.successfully') as string,
        error: t('common:processing.failed') as string,
      },
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
  };
  const actualReportIndex = reports.findIndex((item) => item.planningReportType === 'fulfilled');
  const realizado2 = reports.find((item) => item.planningReportType === 'fulfilled'.toLowerCase());

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 24px)',
        maxHeight: 'calc(100vh - 24px)',
        flexGrow: 'inherit',
      }}
    >
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        <ModalPageTitle title={t('comment.rubric.values')} />
        <Box sx={{ width: '100%', height: theme.spacing(0.25), bgcolor: 'grey.300', mb: 1 }} />

        {reports.map((item, index) => (
          <ReportItem
            key={item.id}
            name={item.planningReportType}
            value={item.value}
            justify={item.justify}
            index={index}
            isLast={index === reports.length - 1}
            onJustifyChangeWithIndex={handleJustificationChange}
          />
        ))}
        <Divider sx={{ mt: 2, mb: 1, borderColor: 'rgba(0, 0, 0, 0.12)', width: theme.spacing(70) }} />

        <ReportItem
          name={t('Realizado 2')}
          value={realizado2?.valueSecondary as number}
          justify={realizado2?.justifySecondary as string}
          index={actualReportIndex}
          isLast={actualReportIndex === reports.length - 1}
          onJustifyChangeWithIndex={handleJustifySecondaryChange}
        />
      </Box>

      <Box sx={{ mt: 'auto' }}>
        <DrawerButtons onSave={handleSubmit} onCancel={handleCancel} />
      </Box>
    </Box>
  );
}
